import React, { Component } from 'react';

class DetailPolicyList extends Component {
  componentDidMount() {
    $('.column.right .child').prop('checked', true);
  }

  render() {
    const { policies, policySel } = this.props;

    return (
      <ul>
        {policies
          ? policies.map((policy) => {
              const style = {
                width: '150px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                color: policy.isactive ? '#000000' : '#999999'
              };
              return (
                <li key={policy.idx}>
                  <div className="checkbox pure" style={style}>
                    <label>
                      <input type="checkbox" id={policy.idx} className="child" onChange={policySel} name="policy" />
                      <span />
                      {`ㄴ ${policy.name}`}
                    </label>
                  </div>
                </li>
              );
            })
          : null}
      </ul>
    );
  }
}

export default DetailPolicyList;
